import { createSelector, createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory } from "../common/reducers/utilities";
import { ensureArray } from "../common/utils/arrayUtilities";
import { createEagerSelector, eagerMetaFactory } from "../common/reducers/pendingUpdateSlice";

const epcrNotesSlice = createSlice({
    name: 'epcrNotes',
    initialState: {
        data: {}
    },
    reducers: {
        addOrUpdate: (state, action) => {
            for (const n of ensureArray(action.payload)) {
                const note = { ...n, autogenerated: n.autogenerated === 1 || n.autogenerated === '1' || n.autogenerated === true };
                if (!state.data[note.pcrid]) {
                    state.data[note.pcrid] = [note];
                } else {
                    let idx = state.data[note.pcrid].findIndex(a => note.id === a.id);
                    if (idx >= 0) {
                        state.data[note.pcrid].splice(idx, 1, note);
                    } else {
                        state.data[note.pcrid] = [...state.data[note.pcrid], note];
                    }
                }
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(logout, () => epcrNotesSlice.getInitialState());
    }
});
// #region network operations
const eagerMeta = eagerMetaFactory(epcrNotesSlice.name);
const fetchEpcrNotes = pcrid => network => network.get(`/api/v1/epcrnotes/${encodeURIComponent(pcrid)}`, epcrNotesSlice.actions.addOrUpdate);
export const strikeEpcrNote = (network, data) => {
    return network.put('/api/v1/epcrnote', data, epcrNotesSlice.actions.addOrUpdate, eagerMeta(data.id, { fk: data.pcrid })); // TODO better failure
}
export const addEpcrNote = (network, data) => {
    return network.post('/api/v1/epcrnote', { ...data, autogenerated: data.autogenerated === true || data.autogenerated === '1' || data.autogenerated === 1 ? 1 : 0 }, epcrNotesSlice.actions.addOrUpdate, eagerMeta(data.id, { fk: data.pcrid })); // TODO better failure)
}
// #endregion

// #region selectors
const selectAllEpcrNotes = state => state.epcrNotes.data;

const eagerSelector = createEagerSelector(epcrNotesSlice.name, { mode: 'mapToArray' });
const selectEpcrNotesByID = eagerSelector(createSelector([selectAllEpcrNotes, (notes, pcrid) => pcrid], (notes, pcrid) => notes[pcrid] ?? []));
const selectEpcrNotes = pcrid => state => selectEpcrNotesByID(state, pcrid);

// #endregion

// #region listeners
const listen = {
    epcrNoteAdded: (history, { dispatch }) => dispatch(epcrNotesSlice.actions.addOrUpdate(history)),
    epcrNoteStruck: (history, { dispatch }) => dispatch(epcrNotesSlice.actions.addOrUpdate(history))
}
// #endregion 

export const [useEpcrNotes, realizeEpcrNotes] = dataHookFactory(selectEpcrNotes, initMapFactory(fetchEpcrNotes, listen, pcrid => pcrid?.toString()));

const reducerDetails = { name: epcrNotesSlice.name, reducer: epcrNotesSlice.reducer };
export default reducerDetails;